import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class LogSubscribeService extends BaseService {
    entityName = 'LogSubscribe';
    serviceCode = 'admin';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }
}
